import { render, staticRenderFns } from "./DashboardBasicInfo.vue?vue&type=template&id=d86bdee6&scoped=true"
import script from "./DashboardBasicInfo.vue?vue&type=script&lang=ts"
export * from "./DashboardBasicInfo.vue?vue&type=script&lang=ts"
import style0 from "./DashboardBasicInfo.vue?vue&type=style&index=0&id=d86bdee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86bdee6",
  null
  
)

export default component.exports